export const shortAddress = addr => (addr ? `${addr.slice(0, 6)}…${addr.slice(-4)}` : '—');

export function compact(n, digits = 1) {
    if (n == null || Number.isNaN(n)) return '—';
    return new Intl.NumberFormat('en-US', {notation: 'compact', maximumFractionDigits: digits}).format(n);
}

export const integer = n => (n == null ? '—' : new Intl.NumberFormat('en-US').format(Math.round(n)));

export const percent = (ratio, digits = 1) => (ratio == null ? '—' : `${(ratio * 100).toFixed(digits)}%`);

export function flag(countryCode) {
    if (!countryCode || countryCode.length !== 2) return '🌐';
    return String.fromCodePoint(...[...countryCode.toUpperCase()].map(c => 0x1f1a5 + c.charCodeAt(0)));
}

export function duration(ms) {
    if (ms <= 0) return 'now';
    const minutes = Math.floor(ms / 60000);
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return h ? `${h}h ${String(m).padStart(2, '0')}m` : `${m}m`;
}

export const explorerAccount = addr => `https://explorer.aptoslabs.com/account/${addr}?network=mainnet`;

// Green for healthy, amber for degraded, red for failing, grey when there is no data yet.
export function healthColor(rate) {
    if (rate == null) return 'var(--muted)';
    if (rate >= 0.98) return 'var(--good)';
    if (rate >= 0.9) return 'var(--warn)';
    return 'var(--bad)';
}

export function healthHex(rate) {
    if (rate == null) return '#7c8698';
    if (rate >= 0.98) return '#2ee6a6';
    if (rate >= 0.9) return '#f5b544';
    return '#ff5c6c';
}
